export default __webpack_public_path__ + "static/media/lords-of-xidit.5ba2f56e.jpg";